import React from 'react';
import ReactDOM from 'react-dom/client';
// antd v5 는 공식적으로 React 16~18 을 지원한다.
// 이 패치를 먼저 적용해야 React 19 에서 정상 동작하고 호환성 경고도 사라진다.
// antd v6 로 올리면 제거한다.
import '@ant-design/v5-patch-for-react-19';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { App as AntdApp, ConfigProvider, theme } from 'antd';
import koKR from 'antd/locale/ko_KR';
import { BrowserRouter } from 'react-router-dom';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';
import App from './App';

dayjs.locale('ko');

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 인증 만료(401)는 클라이언트가 토큰 갱신으로 처리하므로 재시도하지 않는다.
      retry: (failureCount, error: unknown) => {
        const status = (error as { status?: number })?.status;
        if (status && status >= 400 && status < 500) return false;
        return failureCount < 2;
      },
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ConfigProvider
      locale={koKR}
      theme={{
        algorithm: theme.defaultAlgorithm,
        token: {
          fontFamily:
            "'Pretendard', -apple-system, BlinkMacSystemFont, 'Malgun Gothic', sans-serif",
          borderRadius: 6,
        },
      }}
    >
      {/* antd 의 App 컨텍스트. message/Modal 훅은 이 안에서만 동작한다. */}
      <AntdApp>
        <QueryClientProvider client={queryClient}>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </QueryClientProvider>
      </AntdApp>
    </ConfigProvider>
  </React.StrictMode>,
);
